import { Component, OnInit } from '@angular/core';
import {LeagueService} from '@core/services/league.service';
import {TeamService} from '@core/services/team.service';
import {StateService} from '@core/services/state.service';
import {AppLeague} from '@shared/models/league';
import { AnalyticsService } from '@utils/services/analytics/analytics.service';
import {EntityType} from '@lib/models/entity/entity-type';
import {LayoutService} from '@utils/services/layout/layout.service';

@Component({
  selector: 'app-team-transfers',
  templateUrl: './team-transfers.component.html',
  styleUrls: ['./team-transfers.component.scss']
})
export class TeamTransfersComponent implements OnInit {
  league: AppLeague;
  entityType = EntityType.Team;
  constructor(public layoutService: LayoutService,
              public teamService: TeamService,
              private leagueService: LeagueService,
              private analyticsService: AnalyticsService) { }

  ngOnInit(): void {
    if (StateService.isBrowser) {
      this.updateInfos();
    }
  }

  updateInfos() {
    const currentTeam = this.teamService.getCurrentTeam();
    const leagueIdForTable = currentTeam.getLeagueForTable();
    if (leagueIdForTable) {
      this.leagueService.getLeague(leagueIdForTable).then(league => {
        this.league = league;
      });
    }
  }

  public onSendPageView(): void {
    this.analyticsService.sendPageView();
  }
}
